/**
 * PDP hook bundle — the store-specific behaviors injected into the shared
 * ProductDetails class (common/product-details.js) by its two construction
 * sites: product.js (PDP) and global/quick-view.js (quickview modal).
 *
 * common/ must not import from custom/ — this module is the single wiring
 * point. Values are verbatim pass-throughs: the debounced functions are
 * module-level singletons, and re-wrapping them would break debounce
 * coalescing across the PDP + quickview ProductDetails instances.
 */
import { getDetailsOvrPricing, getCartPageOvrPricing } from '../shipping/ovr-shipping';
import { debouncedProductDetailsChange } from './extended-product-details-change';
import { debouncedConfiguratorVariantPriceUpdate } from './custom-products';
import { renderRecommendedAccessories } from './recommended-accessories-unified';
import { fireAddToCart } from '../event/ga4-events';
import { trackAddToCartStart } from '../event/pdp-click-analytics';
import optionImageGallery from './option-image-gallery';

export function buildPdpHooks() {
    return {
        detailsOvrPricing: getDetailsOvrPricing,
        cartOvrPricing: getCartPageOvrPricing,
        variantDetailsChange: debouncedProductDetailsChange,
        configuratorPriceUpdate: debouncedConfiguratorVariantPriceUpdate,
        renderAccessories: renderRecommendedAccessories,
        trackAddToCart: fireAddToCart,
        // PDP only: global/quick-view.js removes it.
        trackAddToCartStart,
        optionImageGallery,
    };
}
